import {Router} from '@angular/router';
import {FormBuilder} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';
import {HttpClient} from '@angular/common/http';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {UploadDocumentsComponent} from '../upload-documents/upload-documents.component';

@Component({
    selector: 'app-lenderuploaddocuments',
    templateUrl: './lenderuploaddocuments.component.html',
    styleUrls: ['./lenderuploaddocuments.component.css'],
    providers: [ApiServiceService]
})

export class LenderuploaddocumentsComponent implements OnInit {

    fileNameString: any = [];
    fileNamePhoto: any = [];
    fileNamePassport: any = [];
    fileNameBank: any = [];
    fileNameItr: any = [];
    fileNameDrivinglicense: any = [];
    fileNameVoterid: any = [];
    fileNameAadhaar: any = [];
    fileNameLpg: any = [];
    fileNameTelephone: any = [];
    fileNameElectricity: any = [];

    file: File;
    file2: File;
    file3: File;
    file4: File;
    file5: File;
    file6: File;
    file7: File;
    file8: File;
    file9: File;
    file10: File;
    file11: File;
    file12: File;

    result: any;
    result2: any;
    result3: any;
    result4: any;
    result5: any;
    result6: any;
    result7: any;
    result8: any;
    result9: any;
    result10: any;
    result11: any;
    result12: any;
    result13: any;
    result14: any;
    result15: any;
    result16: any;
    result17: any;
    result18: any;
    result19: any;
    result20: any;
    result21: any;
    result22: any;
    result23: any;
    result24: any;
    result25: any;

    formData: FormData;

    loader = false;
    loader1 = false;
    loader2 = false;
    loader3 = false;
    loader4 = false;
    loader5 = false;
    loader6 = false;
    loader7 = false;
    loader8 = false;
    loader9 = false;
    loader10 = false;
    loader11 = false;
    loader12 = false;

    photoField = false;
    panField = false;
    passportField = false;
    aadhaarField = false;
    drivinglicenseField = false;
    voteridField = false;
    lpgField = false;
    telephoneField = false;
    electricityField = false;
    bankField = false;
    itrField = false;
    docType: string;

    photoError = false;
    panError = false;
    passportError = false;
    aadhaarError = false;
    drivingError = false;
    voterError = false;
    bankError = false;
    itrError = false;
    lpgError = false;
    telephoneError = false;
    electricityError = false;

    photoErrorType = false;
    panErrorType = false;
    passportErrorType = false;
    aadhaarErrorType = false;
    drivingErrorType = false;
    voterErrorType = false;
    bankErrorType = false;
    itrErrorType = false;
    lpgErrorType = false;
    telephoneErrorType = false;
    electricityErrorType = false;

    photoSize = false;
    panSize = false;
    passportSize = false;
    aadhaarSize = false;
    drivingSize = false;
    voterSize = false;
    bankSize = false;
    itrSize = false;
    lpgSize = false;
    telephoneSize = false;
    electricitySize = false;

    photoExistsError = false;
    panExistsError = false;
    passportExistsError = false;
    aadhaarExistsError = false;
    drivingExistsError = false;
    voterExistsError = false;
    bankExistsError = false;
    itrExistsError = false;
    lpgExistsError = false;
    telephoneExistsError = false;
    electricityExistsError = false;

    pan: any;
    photo: any;
    passport: any;
    aadhaar: any;
    driving: any;
    voter: any;
    bank: any;
    salary: any;
    itr: any;
    lpg: any;
    telephone: any;
    electricity: any;

    extradocType: string;
    public aadhaarErrorDisplayText: string;

    constructor(private _fb: FormBuilder, private httpClient: HttpClient, private router: Router, private ref: ApiServiceService, private storageService: StorageService, public analyticsTracker: AnalyticsTracker) {
    }

    async fileChangePan(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.panError = false;
        this.panErrorType = false;
        this.panSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'application/pdf')) {
            if (event.target.files[0].size < 10000000) {
                this.loader = true;
                this.panField = true;
                this.file = event.target.files[0];
                this.formData.append(event.target.name, this.file, this.file.name);

                if (this.fileNameString.length == 0) {

                    this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                    this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                    this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                    this.result = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                    if (this.result.status == 'success') {
                        this.fileNameString = [];
                        for (let i = 0; i < this.result.lender_info.document_upload.length; i++) {
                            if (this.result.lender_info.document_upload[i].type == 'pan') {
                                this.fileNameString.push(this.getFileDetails(this.result.lender_info.document_upload[i]));
                            }
                        }

                        this.loader = false;
                        this.panField = false;
                    } else {
                        //do nothing
                        this.loader = false;
                    }
                } else {
                    const index = this.fileNameString.map(function (o) {
                        return o.file_name;
                    }).indexOf(event.target.files[0].name);
                    if (index == -1) {
                        this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                        this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                        this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                        this.result = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                        if (this.result.status == 'success') {
                            this.fileNameString = [];
                            for (let i = 0; i < this.result.lender_info.document_upload.length; i++) {
                                if (this.result.lender_info.document_upload[i].type == 'pan') {
                                    this.fileNameString.push(this.getFileDetails(this.result.lender_info.document_upload[i]));
                                }
                            }

                            this.loader = false;
                            this.panField = false;
                        } else {
                            this.loader = false;
                        }
                    } else {
                        this.loader = false;
                        this.panExistsError = true;
                        this.panField = false;
                    }
                }
            } else {
                this.loader = false;
                this.panSize = true;
            }

        } else {
            //do nothing
            this.loader = false;
            this.panErrorType = true;
        }
        this.file = null;
        this.pan = null;
    }

    async removeFilePan(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.loader = true;
        this.result2 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result2.status == 'success') {
            if (this.result2.lenderDetail.document_upload.length > 0) {
                this.fileNameString = [];
                this.loader = false;
                for (let i = 0; i < this.result2.lenderDetail.document_upload.length; i++) {
                    if (this.result2.lenderDetail.document_upload[i].type == 'pan') {
                        this.fileNameString.push(this.getFileDetails(this.result2.lender_info.document_upload[i]));
                    }
                }
            } else {
                this.fileNameString = [];
                this.loader = false;
            }
        } else {
            //do nothing
            this.loader = false;
        }
    }

    async fileChangePhoto(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.panError = false;
        this.panErrorType = false;
        this.panSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png')) {
            if (event.target.files[0].size < 10000000) {
                this.loader1 = true;
                this.photoField = true;
                this.file2 = event.target.files[0];

                if (this.fileNamePhoto.length == 0) {

                    this.formData.append(event.target.name, this.file2, this.file2.name);
                    this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                    this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                    this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                    this.result3 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                    if (this.result3.status == 'success') {
                        this.fileNamePhoto = [];
                        for (let i = 0; i < this.result3.lender_info.document_upload.length; i++) {
                            if (this.result3.lender_info.document_upload[i].type == 'photo') {
                                this.fileNamePhoto.push(this.getFileDetails(this.result3.lender_info.document_upload[i]));
                            }
                        }
                        this.loader1 = false;
                        this.photoField = false;

                    } else {
                        //do nothing
                        this.loader1 = false;
                    }
                } else {
                    const index = this.fileNamePhoto.map(function (o) {
                        return o.file_name;
                    }).indexOf(event.target.files[0].name);
                    if (index == -1) {
                        this.formData.append(event.target.name, this.file2, this.file2.name);
                        this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                        this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                        this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                        this.result3 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                        if (this.result3.status == 'success') {
                            this.fileNamePhoto = [];
                            for (let i = 0; i < this.result3.lender_info.document_upload.length; i++) {
                                if (this.result3.lender_info.document_upload[i].type == 'photo') {
                                    this.fileNamePhoto.push(this.getFileDetails(this.result3.lender_info.document_upload[i]));
                                }
                            }
                            this.loader1 = false;
                            this.photoField = false;

                        } else {
                            //do nothing
                            this.loader1 = false;
                        }
                    } else {
                        this.loader1 = false;
                        this.photoExistsError = true;
                        this.photoField = false;
                    }
                }
            } else {
                this.loader1 = false;
                this.panSize = true;
            }

        } else {
            //do nothing
            this.loader1 = false;
            this.photoErrorType = true;
        }
        this.file2 = null;
        this.photo = null;
    }

    async removeFilePhoto(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.loader1 = true;
        this.result5 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result5.status == 'success') {
            if (this.result5.lenderDetail.document_upload.length > 0) {
                this.fileNamePhoto = [];
                this.loader1 = false;
                for (let i = 0; i < this.result5.lenderDetail.document_upload.length; i++) {
                    if (this.result5.lenderDetail.document_upload[i].type == 'photo') {
                        this.fileNamePhoto.push(this.getFileDetails(this.result5.lender_info.document_upload[i]));
                    }
                }
            } else {
                this.fileNamePhoto = [];
                this.loader1 = false;
            }
        } else {
            //do nothing
            this.loader1 = false;
        }
    }

    async fileChangePassport(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.passportError = false;
        this.passportErrorType = false;
        this.passportSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'application/pdf')) {
            if (event.target.files[0].size < 10000000) {
                this.loader2 = true;
                this.passportField = true;
                this.file3 = event.target.files[0];

                if (this.fileNamePassport.length == 0) {

                    this.formData.append(event.target.name, this.file3, this.file3.name);
                    this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                    this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                    this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                    this.result6 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                    if (this.result6.status == 'success') {
                        this.fileNamePassport = [];
                        for (let i = 0; i < this.result6.lender_info.document_upload.length; i++) {
                            if (this.result6.lender_info.document_upload[i].type == 'passport') {
                                this.fileNamePassport.push(this.getFileDetails(this.result6.lender_info.document_upload[i]));
                            }
                        }
                        this.loader2 = false;
                        this.passportField = false;

                    } else {
                        //do nothing
                        this.loader2 = false;
                    }
                } else {
                    const index = this.fileNamePassport.map(function (o) {
                        return o.file_name;
                    }).indexOf(event.target.files[0].name);
                    if (index == -1) {

                        this.formData.append(event.target.name, this.file3, this.file3.name);
                        this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                        this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                        this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                        this.result6 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                        if (this.result6.status == 'success') {
                            this.fileNamePassport = [];
                            for (let i = 0; i < this.result6.lender_info.document_upload.length; i++) {
                                if (this.result6.lender_info.document_upload[i].type == 'passport') {
                                    this.fileNamePassport.push(this.getFileDetails(this.result6.lender_info.document_upload[i]));
                                }
                            }
                            this.loader2 = false;
                            this.passportField = false;

                        } else {
                            //do nothing
                            this.loader2 = false;
                        }
                    } else {
                        this.loader2 = false;
                        this.passportExistsError = true;
                        this.passportField = false;
                    }
                }
            } else {
                this.loader2 = false;
                this.passportSize = true;
            }

        } else {
            //do nothing
            this.loader2 = false;
            this.passportErrorType = true;
        }

    }

    async removeFilePassport(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.loader2 = true;
        this.result7 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result7.status == 'success') {
            if (this.result7.lenderDetail.document_upload.length > 0) {
                this.fileNamePassport = [];
                this.loader2 = false;
                for (let i = 0; i < this.result7.lenderDetail.document_upload.length; i++) {
                    if (this.result7.lenderDetail.document_upload[i].type == 'passport') {
                        this.fileNamePassport.push(this.getFileDetails(this.result7.lender_info.document_upload[i]));
                    }
                }
            } else {
                this.fileNamePassport = [];
                this.loader2 = false;
            }
        } else {
            //do nothing
            this.loader2 = false;
        }
    }

    async fileChangeAadhaar(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.aadhaarError = false;
        this.aadhaarErrorType = false;
        this.aadhaarSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && event.target.files[0].type === 'application/pdf') {
            const filename = (event.target.files[0] as File).name;
            if (UploadDocumentsComponent.MaskedAadhaarFileRegExp.test(filename)) {
                this.aadhaarErrorDisplayText = undefined;
                if (event.target.files[0].size < 10000000) {
                    this.loader6 = true;
                    this.aadhaarField = true;
                    this.file7 = event.target.files[0];

                    if (this.fileNameAadhaar.length == 0) {

                        this.formData.append(event.target.name, this.file7, this.file7.name);
                        this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                        this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                        this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                        this.result14 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                        if (this.result14.status == 'success') {
                            this.fileNameAadhaar = [];
                            for (let i = 0; i < this.result14.lender_info.document_upload.length; i++) {
                                if (this.result14.lender_info.document_upload[i].type == 'aadhaar') {
                                    this.fileNameAadhaar.push(this.getFileDetails(this.result14.lender_info.document_upload[i]));
                                }
                            }
                            this.loader6 = false;
                            this.aadhaarField = false;

                        } else {
                            //do nothing
                            this.loader6 = false;
                        }
                    } else {
                        const index = this.fileNameAadhaar.map(function (o) {
                            return o.file_name;
                        }).indexOf(event.target.files[0].name);
                        if (index == -1) {
                            this.formData.append(event.target.name, this.file7, this.file7.name);
                            this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                            this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                            this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                            this.result14 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                            if (this.result14.status == 'success') {
                                this.fileNameAadhaar = [];
                                for (let i = 0; i < this.result14.lender_info.document_upload.length; i++) {
                                    if (this.result14.lender_info.document_upload[i].type == 'aadhaar') {
                                        this.fileNameAadhaar.push(this.getFileDetails(this.result14.lender_info.document_upload[i]));
                                    }
                                }
                                this.loader6 = false;
                                this.aadhaarField = false;

                            } else {
                                //do nothing
                                this.loader6 = false;
                            }
                        } else {
                            this.loader6 = false;
                            this.aadhaarExistsError = true;
                            this.aadhaarField = false;
                        }
                    }
                } else {
                    this.aadhaarSize = true;
                    this.loader6 = false;
                }
            } else {
                this.aadhaarErrorDisplayText = 'Please try uploading (.pdf) file';
            }
        } else {
            this.aadhaarErrorType = true;
            this.loader6 = false;
        }
        this.file7 = null;
        this.aadhaar = null;
    }

    async removeFileAadhaar(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.loader6 = true;
        this.result15 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result15.status == 'success') {
            if (this.result15.lenderDetail.document_upload.length > 0) {
                this.fileNameAadhaar = [];
                this.loader6 = false;
                for (let i = 0; i < this.result15.lenderDetail.document_upload.length; i++) {
                    if (this.result15.lenderDetail.document_upload[i].type == 'aadhaar') {
                        this.fileNameAadhaar.push(this.getFileDetails(this.result15.lender_info.document_upload[i]));
                    }
                }
            } else {
                this.fileNameAadhaar = [];
                this.loader6 = false;
            }
        } else {
            //do nothing
            this.loader6 = false;
        }
    }

    async fileChangeDrivinglicense(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.drivingErrorType = false;
        this.drivingError = false;
        this.drivingSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'application/pdf')) {
            if (event.target.files[0].size < 10000000) {
                this.loader7 = true;
                this.drivinglicenseField = true;
                this.file8 = event.target.files[0];

                if (this.fileNameDrivinglicense.length == 0) {

                    this.formData.append(event.target.name, this.file8, this.file8.name);
                    this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                    this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                    this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                    this.result16 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                    if (this.result16.status == 'success') {
                        this.fileNameDrivinglicense = [];
                        for (let i = 0; i < this.result16.lender_info.document_upload.length; i++) {
                            if (this.result16.lender_info.document_upload[i].type == 'driving') {
                                this.fileNameDrivinglicense.push(this.getFileDetails(this.result16.lender_info.document_upload[i]));
                            }
                        }
                        this.loader7 = false;
                        this.drivinglicenseField = false;

                    } else {
                        //do nothing
                        this.loader7 = false;
                    }
                } else {
                    const index = this.fileNameDrivinglicense.map(function (o) {
                        return o.file_name;
                    }).indexOf(event.target.files[0].name);
                    if (index == -1) {
                        this.formData.append(event.target.name, this.file8, this.file8.name);
                        this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                        this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                        this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                        this.result16 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                        if (this.result16.status == 'success') {
                            this.fileNameDrivinglicense = [];
                            for (let i = 0; i < this.result16.lender_info.document_upload.length; i++) {
                                if (this.result16.lender_info.document_upload[i].type == 'driving') {
                                    this.fileNameDrivinglicense.push(this.getFileDetails(this.result16.lender_info.document_upload[i]));
                                }
                            }
                            this.loader7 = false;
                            this.drivinglicenseField = false;

                        } else {
                            //do nothing
                            this.loader7 = false;
                        }
                    } else {
                        this.loader7 = false;
                        this.drivingExistsError = true;
                        this.drivinglicenseField = false;
                    }

                }
            } else {
                this.drivingSize = true;
                this.loader7 = false;
            }

        } else {
            this.drivingErrorType = true;
            this.loader7 = false;
        }
        this.file8 = null;
        this.driving = null;
    }

    async removeFileDrivinglicense(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.loader7 = true;
        this.result17 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result17.status == 'success') {
            if (this.result17.lenderDetail.document_upload.length > 0) {
                this.fileNameDrivinglicense = [];
                this.loader7 = false;
                for (let i = 0; i < this.result17.lenderDetail.document_upload.length; i++) {
                    if (this.result17.lenderDetail.document_upload[i].type == 'driving') {
                        this.fileNameDrivinglicense.push(this.getFileDetails(this.result17.lender_info.document_upload[i]));
                    }
                }
            } else {
                this.fileNameDrivinglicense = [];
                this.loader7 = false;
            }
        } else {
            //do nothing
            this.loader7 = false;
        }
    }

    async fileChangeVoterid(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.voterErrorType = false;
        this.voterError = false;
        this.voterSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'application/pdf')) {
            if (event.target.files[0].size < 10000000) {
                this.loader8 = true;
                this.drivinglicenseField = true;
                this.file9 = event.target.files[0];

                if (this.fileNameVoterid.length == 0) {

                    this.formData.append(event.target.name, this.file9, this.file9.name);
                    this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                    this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                    this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                    this.result18 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                    if (this.result18.status == 'success') {
                        this.fileNameVoterid = [];
                        for (let i = 0; i < this.result18.lender_info.document_upload.length; i++) {
                            if (this.result18.lender_info.document_upload[i].type == 'voter') {
                                this.fileNameVoterid.push(this.getFileDetails(this.result18.lender_info.document_upload[i]));
                            }
                        }
                        this.loader8 = false;
                        this.drivinglicenseField = false;

                    } else {
                        //do nothing
                        this.loader8 = false;
                    }
                } else {
                    const index = this.fileNameVoterid.map(function (o) {
                        return o.file_name;
                    }).indexOf(event.target.files[0].name);
                    if (index == -1) {
                        this.formData.append(event.target.name, this.file9, this.file9.name);
                        this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                        this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                        this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                        this.result18 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                        if (this.result18.status == 'success') {
                            this.fileNameVoterid = [];
                            for (let i = 0; i < this.result18.lender_info.document_upload.length; i++) {
                                if (this.result18.lender_info.document_upload[i].type == 'voter') {
                                    this.fileNameVoterid.push(this.getFileDetails(this.result18.lender_info.document_upload[i]));
                                }
                            }
                            this.loader8 = false;
                            this.drivinglicenseField = false;

                        } else {
                            //do nothing
                            this.loader8 = false;
                        }
                    } else {
                        this.loader8 = false;
                        this.voterExistsError = true;
                        this.voteridField = false;
                    }
                }
            } else {
                this.voterSize = true;
                this.loader8 = false;
            }

        } else {
            this.voterErrorType = true;
            this.loader8 = false;
        }

    }

    async removeFileVoterid(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.loader8 = true;
        this.result19 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result19.status == 'success') {
            if (this.result19.lenderDetail.document_upload.length > 0) {
                this.fileNameVoterid = [];
                this.loader8 = false;
                for (let i = 0; i < this.result19.lenderDetail.document_upload.length; i++) {
                    if (this.result19.lenderDetail.document_upload[i].type == 'voter') {
                        this.fileNameVoterid.push(this.getFileDetails(this.result19.lender_info.document_upload[i]));
                    }
                }
            } else {
                this.fileNameVoterid = [];
                this.loader8 = false;
            }
        } else {
            //do nothing
            this.loader8 = false;
        }
    }

    async fileChangeBank(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.bankErrorType = false;
        this.bankError = false;
        this.bankSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'application/pdf')) {
            if (event.target.files[0].size < 10000000) {
                this.loader3 = true;
                this.bankField = true;
                this.file4 = event.target.files[0];
                this.formData.append(event.target.name, this.file4, this.file4.name);
                this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                this.formData.append('token', this.storageService.getItem(Keys.TOKEN));

                this.result8 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                if (this.result8.status == 'success') {
                    this.fileNameBank = [];
                    for (let i = 0; i < this.result8.lender_info.document_upload.length; i++) {
                        if (this.result8.lender_info.document_upload[i].type == 'bank') {
                            this.fileNameBank.push({
                                file_name: this.result8.lender_info.document_upload[i].file_name,
                                _id: this.result8.lender_info.document_upload[i]._id
                            });
                            console.log(this.fileNameBank);
                        }
                    }
                    this.loader3 = false;
                    this.bankField = false;

                } else {
                    //do nothing
                    this.loader3 = false;
                }
            } else {
                this.bankSize = true;
                this.loader3 = false;
            }

        } else {
            this.bankErrorType = true;
            this.loader3 = false;
        }

    }

    async removeFileBank(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.loader3 = true;
        this.result9 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result9.status == 'success') {
            if (this.result9.lenderDetail.document_upload.length > 0) {
                this.fileNameBank = [];
                this.loader3 = false;
                for (let i = 0; i < this.result9.lenderDetail.document_upload.length; i++) {
                    if (this.result9.lenderDetail.document_upload[i].type == 'bank') {
                        this.fileNameBank.push({
                            file_name: this.result9.lenderDetail.document_upload[i].file_name,
                            _id: this.result9.lenderDetail.document_upload[i]._id
                        });
                        console.log(this.fileNameBank);
                    }
                }
            } else {
                this.fileNameBank = [];
                this.loader3 = false;
            }
        } else {
            //do nothing
            this.loader3 = false;
        }
    }

    async fileChangeItr(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.itrErrorType = false;
        this.itrError = false;
        this.itrSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'application/pdf')) {
            if (event.target.files[0].size < 10000000) {
                this.loader5 = true;
                this.itrField = true;
                this.file6 = event.target.files[0];
                this.formData.append(event.target.name, this.file6, this.file6.name);
                this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                this.formData.append('token', this.storageService.getItem(Keys.TOKEN));
                console.log(this.formData);

                this.result12 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                if (this.result12.status == 'success') {
                    this.fileNameItr = [];
                    for (let i = 0; i < this.result12.lender_info.document_upload.length; i++) {
                        if (this.result12.lender_info.document_upload[i].type == 'itr') {
                            this.fileNameItr.push({
                                file_name: this.result12.lender_info.document_upload[i].file_name,
                                _id: this.result12.lender_info.document_upload[i]._id
                            });
                            console.log(this.fileNameItr);
                        }
                    }
                    this.loader5 = false;
                    this.itrField = false;

                } else {
                    //do nothing
                    this.loader5 = false;
                }
            } else {
                this.itrSize = true;
                this.loader5 = false;
            }

        } else {
            this.itrErrorType = true;
            this.loader5 = false;
        }

    }

    async removeFileItr(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.loader5 = true;
        this.result13 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result13.status == 'success') {
            if (this.result13.lenderDetail.document_upload.length > 0) {
                this.fileNameItr = [];
                this.loader5 = false;
                for (let i = 0; i < this.result13.lenderDetail.document_upload.length; i++) {
                    if (this.result13.lenderDetail.document_upload[i].type == 'itr') {
                        this.fileNameItr.push({
                            file_name: this.result13.lenderDetail.document_upload[i].file_name,
                            _id: this.result13.lenderDetail.document_upload[i]._id
                        });
                        console.log(this.fileNameItr);
                    }
                }
            } else {
                this.fileNameItr = [];
                this.loader5 = false;
            }
        } else {
            //do nothing
            this.loader5 = false;
        }
    }

    async fileChangeLpg(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.lpgExistsError = false;
        this.lpgExistsError = false;
        this.telephoneExistsError = false;
        this.electricityExistsError = false;
        this.lpgError = false;
        this.lpgErrorType = false;
        this.lpgSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'application/pdf')) {
            if (event.target.files[0].size < 10000000) {
                this.loader10 = true;
                this.lpgField = true;
                this.file10 = event.target.files[0];

                if (this.fileNameLpg.length == 0) {

                    this.formData.append(event.target.name, this.file10, this.file10.name);
                    this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                    this.formData.append('token', this.storageService.getItem(Keys.TOKEN));
                    this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                    console.log(this.formData);

                    this.result20 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                    if (this.result20.status == 'success') {
                        this.fileNameLpg = [];
                        for (let i = 0; i < this.result20.lender_info.document_upload.length; i++) {
                            if (this.result20.lender_info.document_upload[i].type == 'lpg') {
                                this.fileNameLpg.push(this.getFileDetails(this.result20.lender_info.document_upload[i]));
                                console.log(this.fileNameLpg);
                            }
                        }
                        this.loader10 = false;
                        this.lpgField = false;

                    } else {
                        this.loader10 = false;
                    }
                } else {
                    const index = this.fileNameLpg.map(function (o) {
                        return o.file_name;
                    }).indexOf(event.target.files[0].name);
                    console.log(index);
                    if (index == -1) {
                        this.formData.append(event.target.name, this.file10, this.file10.name);
                        this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                        this.formData.append('token', this.storageService.getItem(Keys.TOKEN));
                        this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                        console.log(this.formData);

                        this.result20 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                        if (this.result20.status == 'success') {
                            this.fileNameLpg = [];
                            for (let i = 0; i < this.result20.lender_info.document_upload.length; i++) {
                                if (this.result20.lender_info.document_upload[i].type == 'lpg') {
                                    this.fileNameLpg.push(this.getFileDetails(this.result20.lender_info.document_upload[i]));
                                    console.log(this.fileNameLpg);
                                }
                            }
                            this.loader10 = false;
                            this.lpgField = false;

                        } else {
                            this.loader10 = false;
                        }
                    } else {
                        this.loader10 = false;
                        this.lpgExistsError = true;
                        this.lpgField = false;
                    }

                }
            } else {
                this.lpgSize = true;
                this.loader10 = false;
            }

        } else {
            this.lpgErrorType = true;
            this.loader10 = false;
        }
        this.file10 = null;
        this.lpg = null;
    }

    async removeFileLpg(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.lpgExistsError = false;
        this.telephoneExistsError = false;
        this.electricityExistsError = false;
        this.loader10 = true;
        this.result21 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result21.status == 'success') {
            if (this.result21.lenderDetail.document_upload.length > 0) {
                this.fileNameLpg = [];
                this.loader10 = false;
                for (let i = 0; i < this.result21.lenderDetail.document_upload.length; i++) {
                    if (this.result21.lenderDetail.document_upload[i].type == 'lpg') {
                        this.fileNameLpg.push(this.getFileDetails(this.result21.lender_info.document_upload[i]));
                        console.log(this.fileNameLpg);
                    }
                }
            } else {
                this.fileNameLpg = [];
                this.loader10 = false;
            }
        } else {
            this.loader10 = false;
        }
    }

    async fileChangeTelephone(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.lpgExistsError = false;
        this.lpgExistsError = false;
        this.telephoneExistsError = false;
        this.electricityExistsError = false;
        this.telephoneError = false;
        this.telephoneErrorType = false;
        this.telephoneSize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'application/pdf')) {
            if (event.target.files[0].size < 10000000) {
                this.loader11 = true;
                this.telephoneField = true;
                this.file11 = event.target.files[0];

                if (this.fileNameTelephone.length == 0) {

                    this.formData.append(event.target.name, this.file11, this.file11.name);
                    this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                    this.formData.append('token', this.storageService.getItem(Keys.TOKEN));
                    this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                    console.log(this.formData);

                    this.result22 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                    if (this.result22.status == 'success') {
                        this.fileNameTelephone = [];
                        for (let i = 0; i < this.result22.lender_info.document_upload.length; i++) {
                            if (this.result22.lender_info.document_upload[i].type == 'telephone') {
                                this.fileNameTelephone.push(this.getFileDetails(this.result22.lender_info.document_upload[i]));
                                console.log(this.fileNameTelephone);
                            }
                        }
                        this.loader11 = false;
                        this.telephoneField = false;

                    } else {
                        this.loader11 = false;
                    }
                } else {
                    const index = this.fileNameTelephone.map(function (o) {
                        return o.file_name;
                    }).indexOf(event.target.files[0].name);
                    console.log(index);
                    if (index == -1) {
                        this.formData.append(event.target.name, this.file11, this.file11.name);
                        this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                        this.formData.append('token', this.storageService.getItem(Keys.TOKEN));
                        this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                        console.log(this.formData);

                        this.result22 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                        if (this.result22.status == 'success') {
                            this.fileNameTelephone = [];
                            for (let i = 0; i < this.result22.lender_info.document_upload.length; i++) {
                                if (this.result22.lender_info.document_upload[i].type == 'telephone') {
                                    this.fileNameTelephone.push(this.getFileDetails(this.result22.lender_info.document_upload[i]));
                                    console.log(this.fileNameTelephone);
                                }
                            }
                            this.loader11 = false;
                            this.telephoneField = false;

                        } else {
                            this.loader11 = false;
                        }
                    } else {
                        this.loader11 = false;
                        this.telephoneExistsError = true;
                        this.telephoneField = false;
                    }

                }
            } else {
                this.telephoneSize = true;
                this.loader11 = false;
            }

        } else {
            this.telephoneErrorType = true;
            this.loader11 = false;
        }
        this.file11 = null;
        this.telephone = null;
    }

    async removeFileTelephone(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.telephoneExistsError = false;
        this.lpgExistsError = false;
        this.electricityExistsError = false;
        this.loader11 = true;
        this.result23 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result23.status == 'success') {
            if (this.result23.lenderDetail.document_upload.length > 0) {
                this.fileNameTelephone = [];
                this.loader11 = false;
                for (let i = 0; i < this.result23.lenderDetail.document_upload.length; i++) {
                    if (this.result23.lenderDetail.document_upload[i].type == 'telephone') {
                        this.fileNameTelephone.push(this.getFileDetails(this.result23.lender_info.document_upload[i]));
                        console.log(this.fileNameTelephone);
                    }
                }
            } else {
                this.fileNameTelephone = [];
                this.loader11 = false;
            }
        } else {
            this.loader11 = false;
        }
    }

    async fileChangeElectricity(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.lpgExistsError = false;
        this.lpgExistsError = false;
        this.telephoneExistsError = false;
        this.electricityExistsError = false;
        this.electricityError = false;
        this.electricityErrorType = false;
        this.electricitySize = false;
        this.formData = new FormData();

        if (event.target.files.length > 0 && (event.target.files[0].type == 'image/jpg' || event.target.files[0].type == 'image/jpeg' || event.target.files[0].type == 'image/png' || event.target.files[0].type == 'application/pdf')) {
            if (event.target.files[0].size < 10000000) {
                this.loader12 = true;
                this.electricityField = true;
                this.file12 = event.target.files[0];

                if (this.fileNameElectricity.length == 0) {

                    this.formData.append(event.target.name, this.file12, this.file12.name);
                    this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                    this.formData.append('token', this.storageService.getItem(Keys.TOKEN));
                    this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                    console.log(this.formData);

                    this.result24 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                    if (this.result24.status == 'success') {
                        this.fileNameElectricity = [];
                        for (let i = 0; i < this.result24.lender_info.document_upload.length; i++) {
                            if (this.result24.lender_info.document_upload[i].type == 'electricity') {
                                this.fileNameElectricity.push(this.getFileDetails(this.result24.lender_info.document_upload[i]));
                                console.log(this.fileNameElectricity);
                            }
                        }
                        this.loader12 = false;
                        this.electricityField = false;

                    } else {
                        this.loader12 = false;
                    }
                } else {
                    const index = this.fileNameElectricity.map(function (o) {
                        return o.file_name;
                    }).indexOf(event.target.files[0].name);
                    console.log(index);
                    if (index == -1) {
                        this.formData.append(event.target.name, this.file12, this.file12.name);
                        this.formData.append('lender_id', this.storageService.getItem(Keys.LENDER_ID));
                        this.formData.append('token', this.storageService.getItem(Keys.TOKEN));
                        this.formData.append('profile_id', this.storageService.getItem(Keys.PROFILE_ID));
                        console.log(this.formData);

                        this.result24 = await this.httpClient.post(this.ref.baseURL() + 'uploadDocumentsLender', this.formData).toPromise();
                        if (this.result24.status == 'success') {
                            this.fileNameElectricity = [];
                            for (let i = 0; i < this.result24.lender_info.document_upload.length; i++) {
                                if (this.result24.lender_info.document_upload[i].type == 'electricity') {
                                    this.fileNameElectricity.push(this.getFileDetails(this.result24.lender_info.document_upload[i]));
                                    console.log(this.fileNameElectricity);
                                }
                            }
                            this.loader12 = false;
                            this.electricityField = false;

                        } else {
                            this.loader12 = false;
                        }
                    } else {
                        this.loader12 = false;
                        this.electricityExistsError = true;
                        this.electricityField = false;
                    }

                }
            } else {
                this.electricitySize = true;
                this.loader12 = false;
            }

        } else {
            this.electricityErrorType = true;
            this.loader12 = false;
        }
        this.file12 = null;
        this.electricity = null;
    }

    async removeFileElectricity(event) {
        this.photoExistsError = false;
        this.panExistsError = false;
        this.passportExistsError = false;
        this.aadhaarExistsError = false;
        this.drivingExistsError = false;
        this.voterExistsError = false;
        this.telephoneExistsError = false;
        this.lpgExistsError = false;
        this.electricityExistsError = false;
        this.loader12 = true;
        this.result25 = await this.httpClient.post(this.ref.baseURL() + 'removeUploadedFileLender', {
            lender_id: this.storageService.getItem(Keys.LENDER_ID),
            token: this.storageService.getItem(Keys.TOKEN),
            profile_id: this.storageService.getItem(Keys.PROFILE_ID),
            file_id: event.target.id
        }).toPromise();
        if (this.result25.status == 'success') {
            if (this.result25.lenderDetail.document_upload.length > 0) {
                this.fileNameElectricity = [];
                this.loader12 = false;
                for (let i = 0; i < this.result25.lenderDetail.document_upload.length; i++) {
                    if (this.result25.lenderDetail.document_upload[i].type == 'electricity') {
                        this.fileNameElectricity.push(this.getFileDetails(this.result25.lender_info.document_upload[i]));
                        console.log(this.fileNameElectricity);
                    }
                }
            } else {
                this.fileNameElectricity = [];
                this.loader12 = false;
            }
        } else {
            this.loader12 = false;
        }
    }

    async goToSummary() {
        this.photoError = false;
        this.panError = false;
        this.passportError = false;
        this.aadhaarError = false;
        this.drivingError = false;
        this.voterError = false;
        this.bankError = false;
        this.itrError = false;
        this.lpgError = false;
        this.telephoneError = false;
        this.electricityError = false;

        if (this.fileNameString.length == 0) {
            this.panError = true;
        }
        if (this.fileNamePhoto.length == 0) {
            this.photoError = true;
        }
        if (this.fileNameItr.length == 0) {
            this.itrError = true;
        }
        if (this.fileNameBank.length == 0) {
            this.bankError = true;
        }
        if (this.fileNameAadhaar.length == 0) {
            this.aadhaarError = true;
        }
        if (this.fileNameDrivinglicense.length == 0) {
            this.drivingError = true;
        }
        if (this.fileNamePassport.length == 0) {
            this.passportError = true;
        }
        if (this.fileNameVoterid.length == 0) {
            this.voterError = true;
        }
        if (this.fileNameLpg.length == 0) {
            this.lpgError = true;
        }
        if (this.fileNameTelephone.length == 0) {
            this.telephoneError = true;
        }
        if (this.fileNameElectricity.length == 0) {
            this.electricityError = true;
        }

        if (this.docType == 'aadhaar') {
            if ((this.fileNameString.length > 0) && (this.fileNamePhoto.length > 0) && (this.fileNameAadhaar.length > 0)) {
                this.storageService.saveItem(Keys.UPLOAD_DOCUMENTS, 'true');
                this.router.navigate(['/lendersummary']);
            } else {
                //do nothing
            }
        } else if (this.docType == 'drivinglicense') {
            if ((this.fileNameString.length > 0) && (this.fileNamePhoto.length > 0) && (this.fileNameDrivinglicense.length > 0)) {
                this.storageService.saveItem(Keys.UPLOAD_DOCUMENTS, 'true');
                this.router.navigate(['/lendersummary']);
            } else {
                //do nothing
            }
        } else if (this.docType == 'passport') {
            if ((this.fileNameString.length > 0) && (this.fileNamePhoto.length > 0) && (this.fileNamePassport.length > 0)) {
                this.storageService.saveItem(Keys.UPLOAD_DOCUMENTS, 'true');
                this.router.navigate(['/lendersummary']);
            } else {
                //do nothing
            }
        } else if (this.docType == 'voterid') {
            if ((this.fileNameString.length > 0) && (this.fileNamePhoto.length > 0) && (this.fileNameVoterid.length > 0)) {
                this.storageService.saveItem(Keys.UPLOAD_DOCUMENTS, 'true');
                this.router.navigate(['/lendersummary']);
            } else {
                //do nothing
            }
        } else if (this.docType == 'lpg') {
            if ((this.fileNameString.length > 0) && (this.fileNamePhoto.length > 0) && (this.fileNameLpg.length > 0)) {
                this.storageService.saveItem(Keys.UPLOAD_DOCUMENTS, 'true');
                this.router.navigate(['/lendersummary']);
            } else {
                //do nothing
            }
        } else if (this.docType == 'telephone') {
            if ((this.fileNameString.length > 0) && (this.fileNamePhoto.length > 0) && (this.fileNameTelephone.length > 0)) {
                this.storageService.saveItem(Keys.UPLOAD_DOCUMENTS, 'true');
                this.router.navigate(['/lendersummary']);
            } else {
                //do nothing
            }
        } else if (this.docType == 'electricity') {
            if ((this.fileNameString.length > 0) && (this.fileNamePhoto.length > 0) && (this.fileNameElectricity.length > 0)) {
                this.storageService.saveItem(Keys.UPLOAD_DOCUMENTS, 'true');
                this.router.navigate(['/lendersummary']);
            } else {
                //do nothing
            }
        }
    }

    async ngOnInit() {
        if (this.storageService.getItem('extradocType') == 'aadhaar') {
            this.extradocType = 'aadhaar';
        }

        this.result4 = await this.httpClient.post(this.ref.baseURL() + 'getLenderInfoDetails',
            {
                lender_id: this.storageService.getItem(Keys.LENDER_ID),
                profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                token: this.storageService.getItem(Keys.TOKEN)
            }).toPromise();
        if (this.result4.status == 'success') {
            this.docType = this.result4.lender_info.correspondence_address.proofs[0].proofType;

            for (let i = 0; i < this.result4.lender_info.document_upload.length; i++) {
                if (this.result4.lender_info.document_upload[i].type == 'pan') {
                    this.fileNameString.push(this.getFileDetails(this.result4.lender_info.document_upload[i]));
                    console.log(this.fileNameString);
                } else if (this.result4.lender_info.document_upload[i].type == 'photo') {
                    this.fileNamePhoto.push(this.getFileDetails(this.result4.lender_info.document_upload[i]));
                    console.log(this.fileNamePhoto);
                } else if (this.result4.lender_info.document_upload[i].type == 'passport') {
                    this.fileNamePassport.push(this.getFileDetails(this.result4.lender_info.document_upload[i]));
                    console.log(this.fileNamePassport);
                } else if (this.result4.lender_info.document_upload[i].type == 'aadhaar') {
                    this.fileNameAadhaar.push(this.getFileDetails(this.result4.lender_info.document_upload[i]));
                    console.log(this.fileNameAadhaar);
                } else if (this.result4.lender_info.document_upload[i].type == 'driving') {
                    this.fileNameDrivinglicense.push(this.getFileDetails(this.result4.lender_info.document_upload[i]));
                    console.log(this.fileNameDrivinglicense);
                } else if (this.result4.lender_info.document_upload[i].type == 'voter') {
                    this.fileNameVoterid.push(this.getFileDetails(this.result4.lender_info.document_upload[i]));
                    console.log(this.fileNameVoterid);
                } else if (this.result4.lender_info.document_upload[i].type == 'lpg') {
                    this.fileNameLpg.push(this.getFileDetails(this.result4.lender_info.document_upload[i]));
                    console.log(this.fileNameLpg);
                } else if (this.result4.lender_info.document_upload[i].type == 'telephone') {
                    this.fileNameTelephone.push(this.getFileDetails(this.result4.lender_info.document_upload[i]));
                    console.log(this.fileNameTelephone);
                } else if (this.result4.lender_info.document_upload[i].type == 'electricity') {
                    this.fileNameElectricity.push(this.getFileDetails(this.result4.lender_info.document_upload[i]));
                    console.log(this.fileNameElectricity);
                }

                /*else if(this.result4.lender_info.document_upload[i].type == 'bankstatement')
                 {
                 this.fileNameBank.push({file_name:this.result4.lender_info.document_upload[i].file_name,_id:this.result4.lender_info.document_upload[i]._id})
                 console.log(this.fileNameBank)
                 }
                 else if(this.result4.lender_info.document_upload[i].type == 'itr')
                 {
                 this.fileNameItr.push({file_name:this.result4.lender_info.document_upload[i].file_name,_id:this.result4.lender_info.document_upload[i]._id})
                 console.log(this.fileNameItr)
                 }*/
            }
        } else {
            //do nothing
        }
    }

    getFileDetails(document) {
        return {_id: document._id, file_name: document.file_name, source: document.source};
    }
}
